module.exports = __webpack_public_path__ + "static/media/1k7.237998cb.JPG";